const state = {
  device: {
    lang: 'zh-cn',
    udid: 'test',
    platform: '1',
    platformType: '0',
    token: ''
  }
}

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, {})
  },
  SET_DEVICE_DATA: (state, data) => {
    for (const key in data) {
      state.device[key] = data[key]
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    console.log('after state.token', state.token)
  }
}

const actions = {
  // user login
  setDeviceData ({ commit }, data) {
    const {token} = data
    return new Promise((resolve, reject) => {
      commit('SET_DEVICE_DATA', data)
      commit('SET_TOKEN', token)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/device.js